// @flow
import * as React from 'react'
import { withValues } from 'mz-intl'
import { createField } from '../Field'
import TextField from '../TextField'
import messages from './messages.intl'

// Types
import type { Props as BaseFieldProps } from '../../core/BaseField'

export type Props = BaseFieldProps

/* eslint-disable max-len, no-useless-escape */
export const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
/* eslint-enable max-len, no-useless-escape */

const EmailField = createField(
  (props, _, options) => <TextField {...props} {...options} />,
  {
    validate: (value, options) => {
      if (!options?.required && !(value || '').trim()) return null
      if (!EMAIL_REGEXP.test(value)) return messages.EMAIL_INVALID_ERROR

      if (options.allowedEmailDomains?.length > 0) {
        const hasSomeDomain = options.allowedEmailDomains.some((x) =>
          value.trim().toLowerCase().endsWith(`@${x}`.toLowerCase())
        )
        if (!hasSomeDomain) {
          return withValues(messages.EMAIL_INVALID_DOMAIN, {
            domains: options.allowedEmailDomains.join(', '),
          })
        }
      }

      return null
    },
    normalize: (value) => {
      return (value || '').trim()
    },
  }
)

export default EmailField
